
import { ICheckBoxListUser } from './user';
// import {ICustomHoliday,CCustomHoliday} from './custom-holiday';

export interface IWorkstyle {
  workstyleID: number;
  name: string;
  startTime: string;
  endTime: string;
  restTime: string;
  holiday: string[];
  cutoffDay: number;
  weekFirst: number;
  yearFirst: string;
  legalHoliday: number;
}

export class CWorkstyle implements IWorkstyle {
  public workstyleID = 0;
  public name = '';
  public startTime = '10:00';
  public endTime = '19:00';
  public restTime = '01:00';
  public holiday = ['土', '日', '祝日'];
  public cutoffDay = 99;
  public weekFirst = 0;
  public yearFirst = '';
  public legalHoliday = 1;
}

export interface IUserWorkstyle {
  userID: number;
  workstyleID: number;
}

// export interface IUserWorkstyle2 {
//   userAccountID: number;
//   workstyleAccountID: number;
//   userID: number;
//   workstyleID: number;
//   workstyleName: string;
//   sei: string;
//   mei: string;
//   departmentID: number;
//   departmentName: string;
//   prdepartmentName: string;
//   mailAddress: string;
// }

export class CUserWorkstyle implements IUserWorkstyle {
  public userID = 0;
  public workstyleID = 0;
}

export interface IWorkstyleUser extends ICheckBoxListUser {
  workstyleID: number;
  workstyle: string;
}
